import { Stack, Typography } from '@mui/material';
import { projects } from './projects';
import { ProjectCard } from './components/ProjectCard';

export const ProjectsPage = () => {
  return (
    <Stack spacing={4} sx={{ height: '100%' }}>
      <Typography
        variant="h3"
        sx={{ color: 'primary.main', letterSpacing: '0.08em' }}
      >
        $ ls ~/projects
      </Typography>

      <Stack spacing={3}>
        {projects.map((project) => (
          <ProjectCard key={project.title} project={project} />
        ))}
        {/* Spacer for taskbar */}
        <div />
      </Stack>
    </Stack>
  );
};
